import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { StringUtilsService } from 'app/shared/string-utils.service';
import { WP_API_CURSOS_POS_GRADUACAO } from 'app/config';

export const URL_POSGRADUACAO = WP_API_CURSOS_POS_GRADUACAO + `/cursosposgraduacao/mestrado/`;

@Injectable()
export class MestradoService {
    
    constructor(private http: HttpClient, private stringUtils: StringUtilsService) { }

    listCursoMestrado(){
        return this.http
        .get<any>(URL_POSGRADUACAO)
    }

    listCursoMestradoId(id){
        return this.http
        .get<any>(URL_POSGRADUACAO +`${id}`)
    }

    listCursoName(id: string): Promise<any>{
       return new Promise<any>((resolve, reject) => {
           this.http.get<any>(URL_POSGRADUACAO+`${id}`).subscribe(slugEdital => {
               let slug = this.stringUtils.textoParaSlug(slugEdital.cursosposgraduacao[0].nome);
               resolve(slug);
           },
           err => {
             reject(err);
           });
       });
    }
}
